import * as TYPES from './types';
export default {
    [TYPES.SET_LIST](state, payload) {
        state.list = [...payload];
    }
};
